module.exports = __webpack_public_path__ + "img/pseudo.efda40d2.png";